var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7541_11035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66602C14.6 1.66602 18.3333 5.39935 18.3333 9.99935C18.3333 14.5993 14.6 18.3327 9.99996 18.3327C5.39996 18.3327 1.66663 14.5993 1.66663 9.99935C1.66663 5.39935 5.39996 1.66602 9.99996 1.66602ZM9.99996 16.666C13.6833 16.666 16.6666 13.6827 16.6666 9.99935C16.6666 6.31602 13.6833 3.33268 9.99996 3.33268C6.31663 3.33268 3.33329 6.31602 3.33329 9.99935C3.33329 13.6827 6.31663 16.666 9.99996 16.666ZM12.9466 5.87435L14.125 7.05268L9.99996 11.1777L8.82163 9.99935L12.9466 5.87435Z",
    fill: "#213D69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7541_11035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.64d7c446599cf88f7b1f853ab31672ca.svg";
export { ForwardRef as ReactComponent };